import React, { useState } from "react";
import { useSelector } from "react-redux";

import Banner from "../../containers/helpers/genericBanner";
import styles from "../../styles/Hero.module.scss";
import classnames from "classnames";
import { redirectToDeviceDownloadPage } from "../../utils/routes";
import currentUserInfo from "../../selectors/currentUserInfo";
import { isMobile } from "react-device-detect";

function renderButtonArray(heroButtonArray, buttonArrayClassName, currentHoverIndex, setHoverIndex, buttonClick) {
  const buttons = heroButtonArray.map((heroButton, i) => {
    const {buttonText, buttonLink, buttonSubText, isAnchor, hoverStyle={}, borderColor, buttonColor} = heroButton
    const hover = currentHoverIndex === i
    const buttonChildren = <>
        <div className={styles.heroButtonText}>
          {buttonText}
          {buttonSubText && <span className={styles.heroButtonSubText}>{buttonSubText}</span>}
        </div>    
      </>
    if (isAnchor) {
      return (
        <a key={i} href={buttonLink}>
          {buttonChildren}
        </a>
      )
    }
    else {
      return (
        <button key={i} className={styles.heroButton}
          style={{
            backgroundColor: hover
              ? hoverStyle.buttonColor
              : buttonColor,
            borderColor: hover
              ? hoverStyle.borderColor
              : borderColor,
            color: hover ? hoverStyle.textColor : null,
          }}
          onClick={() => buttonClick(heroButton)}
          onMouseEnter={() => {
            setHoverIndex(i);
          }}
          onMouseLeave={() => {
            setHoverIndex(-1);
          }}
        >
          {buttonChildren}
        </button>
      )
    }
  })
  return (
    <div className={classnames(styles.heroButtonArray, buttonArrayClassName)}>
      {buttons}
    </div>
  )
}

const Hero = (props) => {
  const currentUser = useSelector(currentUserInfo);
  const [hoverIndex, setHoverIndex] = useState(-1);

  const {
    router,
    heroImage,
    heroTitle,
    heroSubText,
    hasButton,
    heroButton,
    unfoldFuton,
    futonData,
    product,
    showHeadrest,
    footerStyle,
    parallax,
    className,
    titleContainerClassName,
    buttonArrayClassName
  } = props;
  const bannerStyle = {
    width: "100%",
    position: "relative",
  };

  const buttonClick = (heroButton) => {
    if (hasButton) {
      let link = heroButton.buttonLink;
      if (heroButton.isLinkExternal) {
        window.open(link, "_blank");
      } else {
        if (heroButton.linkedToDownloads) {
          redirectToDeviceDownloadPage(props.router, product, currentUser);
        } else {
          props.router.history.push(link);
        }
      }
    }
  };

  const titleWrapperClass = classnames({
    [styles.titleWrapper]: true,
    [styles.footer]: footerStyle && window.innerWidth > 1030,
  }, titleContainerClassName);

  const heroTitleClass = classnames({
    [styles.heroTitle]: true,
    [styles.footer]: footerStyle && window.innerWidth > 1030,
  });

  const renderTextAndButton = (title, subtext) => {
    let heroButtons = Array.isArray(heroButton)? heroButton : [heroButton]
    if (isMobile) {
      heroButtons = heroButtons.filter(buttonData => !buttonData.desktopOnly)
    }
    // const hasSingleButton = hasButton && !hasButtonArray

    return (
      <div
        className={titleWrapperClass}
        style={{
          position: heroTitle ? "absolute" : "relative",
        }}
      >
        {title && <h1 className={heroTitleClass}>{title}</h1>}
        {subtext && <div className={styles.heroSubtext}>{subtext}</div>}
        {
          }
        {renderButtonArray(heroButtons, buttonArrayClassName, hoverIndex, setHoverIndex, buttonClick)}
      </div>
    );
  };

  return (
    <div className={classnames(styles.container, className)}>
      {showHeadrest && (
        <Banner
          router={router}
          bannerStyle={bannerStyle}
          desktopImage={heroImage.desktopUrl}
          mobileImage={heroImage.mobileUrl}
          lowResDesktopImage={heroImage.lowResDesktopImageUrl}
          alt={heroImage.alt}
          parallax={parallax}
          external={false}
          redirectURL={"/downloads/bb3"}
          mobileBreakpoint={620}
          noRedirect
        >
          {heroTitle && renderTextAndButton(heroTitle, heroSubText)}
        </Banner>
      )}

      {unfoldFuton && (
        <div
          id={"futon"}
          className={classnames(styles.futonCover, styles[product])}
          // style={{ background: futonData.backgroundColor }}
        >
          {futonData.futonLogo && (
            <div className={styles.futonIconCover}>
              <img
                alt={futonData.title}
                src={futonData.futonLogo}
                className={styles.futonIcon}
              />
            </div>
          )}
          <div className={styles.futonTextContainer}>
            {futonData.title &&
              renderTextAndButton(futonData.title, futonData.subtext)}
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;
